export default "__VITE_ASSET__DqplhZE5__"